var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 47.99,
    height: 47.99,
    rx: 8,
    fill: "#FFEDD5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.9918 16.9978H15.9984C14.8943 16.9978 13.9993 17.8929 13.9993 18.997V28.9928C13.9993 30.0969 14.8943 30.992 15.9984 30.992H31.9918C33.0959 30.992 33.9909 30.0969 33.9909 28.9928V18.997C33.9909 17.8929 33.0959 16.9978 31.9918 16.9978Z",
    stroke: "#EA580C",
    strokeWidth: 1.99917,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9993 21.9958H33.9909",
    stroke: "#EA580C",
    strokeWidth: 1.99917,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.7f507597ef066c3fc44f650a730d19d0.svg";
export { ForwardRef as ReactComponent };